import { useState } from "react";

// FIXME: Multiple answer questions

const TeacherPortalQuizQuestionSelector = ({ questions, functionToCallOnClickWithIndex }) => {

    const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0)

    return <>
        <div className="grid grid-cols-12 gap-2 text-left">
            {questions.map((question, index) => {
                return <div key={index} className="col-span-1">
                    <div
                        className={"w-full h-full bg-error text-black cursor-pointer hover:scale-110 " + (index == selectedQuestionIndex ? "border-2 border-[#4f4f4f]" : "border border-[#8f8f8f]")}
                        onClick={() => {
                            setSelectedQuestionIndex(index)
                            functionToCallOnClickWithIndex(index)
                        }
                        }>
                        <div className="bg-[#16CC64] h-full" style={{ width: Math.round((question.statistics.scores_total.achieved / question.statistics.scores_total.maximum_achievable) * 100) + "%" }}></div>
                        <div className="w-full relative -top-full z-[1] text-center">{index + 1}</div>
                    </div>
                </div>
            })
            }
        </div>
    </>
};

export default TeacherPortalQuizQuestionSelector